import {PerformanceType} from '~/modules/Dashboard/models/Performance';

export const dashboardLinks = {
    dashboard: () => '/dashboard',
    performanceByType: (performanceType: PerformanceType | string = PerformanceType.SUMMARY) => `/dashboard/${performanceType}`,
};
